import { h } from "preact";
import { RoutableProps } from "preact-router";
import { addProductToDatabase } from "../../../api/product-api";
import { manufacturingConfigurations } from "../../../App";
import { AccessoriesPrinting } from "../../../components/AccesoriesPrinting";
import "./styles.scss";

export function LunaEMGSerialNumber(props: RoutableProps) {
    return <div class="luna-emg-serial-number-page">
        <AccessoriesPrinting manufacturingConfigurations={manufacturingConfigurations["LunaEMG"] ?? []} serialType="serial-6-base16" generateSerialNumber={(type) => addProductToDatabase(type)}/>
    </div>;
}
